import { render, staticRenderFns } from "./r-bundle-christmas-dialog.vue?vue&type=template&id=072c04dd&scoped=true"
import script from "./r-bundle-christmas-dialog.vue?vue&type=script&lang=js"
export * from "./r-bundle-christmas-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-bundle-christmas-dialog.vue?vue&type=style&index=0&id=072c04dd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072c04dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('072c04dd')) {
      api.createRecord('072c04dd', component.options)
    } else {
      api.reload('072c04dd', component.options)
    }
    module.hot.accept("./r-bundle-christmas-dialog.vue?vue&type=template&id=072c04dd&scoped=true", function () {
      api.rerender('072c04dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-christmas/r-bundle-christmas-dialog.vue"
export default component.exports